module.exports = __webpack_public_path__ + "img/add.ca05c801.svg";